module.exports = __webpack_public_path__ + "img/group4.f5360b2a.png";